import { applicationApi } from '../../common/api';
import { GetLoanListRequest, Loan, LoanReportSummary } from './types';

// Define a service using a base URL and expected endpoints
export const loanApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLoan: builder.query<Loan[], GetLoanListRequest>({
      query: (params) => ({
        url: '/loans',
        method: 'GET',
        params: params,
      }),
      providesTags: [{ type: 'Loan', id: 'LIST' }],
    }),
    getLoan: builder.query<Loan, string>({
      query: (query) => `/loans/${query}`,
    }),
    createLoan: builder.mutation<Loan, any>({
      query: (body) => ({
        url: '/loans',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Loan', id: 'LIST' }],
    }),
    deleteLoan: builder.mutation<any, number>({
      query: (id) => ({
        url: `/loans/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Loan', id: 'LIST' }],
    }),
    updateLoan: builder.mutation<Loan, any>({
      query: (body) => ({
        url: `/loans/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Loan', id: 'LIST' }],
    }),
    markPaid: builder.mutation<Loan, number>({
      query: (id) => ({
        url: `/loans/${id}/mark-paid`,
        method: 'PATCH',
      }),
      invalidatesTags: [{ type: 'Loan', id: 'LIST' }],
    }),
    getLoanReportSummary: builder.query<LoanReportSummary, void>({
      query: () => `/loans/report-summary`,
    }),
    getLoanReportGraph: builder.query<any, any>({
      query: (params) => ({
        url: '/loans/report-graph',
        method: 'GET',
        params: params,
      }),
    }),
    getLoanReportForecast: builder.query<any, any>({
      query: (params) => ({
        url: '/loans/report-forecast',
        method: 'GET',
        params: params,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllLoanQuery,
  useGetLoanQuery,
  useCreateLoanMutation,
  useDeleteLoanMutation,
  useUpdateLoanMutation,
  useMarkPaidMutation,
  useGetLoanReportSummaryQuery,
  useGetLoanReportGraphQuery,
  useGetLoanReportForecastQuery,
} = loanApi;
